import React,{useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default function About() {
    useEffect(()=>{
        AOS.init({duration:1000})
    },[])
  return (
    <section className="about-area page-section scroll-to-page" id="about">
        <div className="custom-container">
            <div className="about-content content-width">
                <div className="section-header">
                    <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                        <i className="lar la-user"></i> About
                    </h4>
                    <h1 className="scroll-animation" data-aos='fade-up'>Unlocking possibilities through<br/> innovative code</h1>
                </div>
                <p className="scroll-animation" data-aos='fade-up'>With several years of hands-on experience in game development, I specialize in Rust server and plugin development, as well as creating powerful Harmony mods. I’m passionate about building immersive, high-performance systems that push the boundaries of what’s possible in modded gameplay.

One of my proudest projects was developing a 10x modded Rust server that grew to over 600 concurrent players — one of the largest of its kind. I’ve had the privilege of collaborating with well-known content creators and organizations, always with a focus on clean, efficient code and real-world results.

I take a straightforward, results-driven approach to development. Whether it’s optimizing backend systems or designing custom mods, I’m motivated by helping others and making a meaningful impact on the gaming community.

I’m proficient in C# and JavaScript, experienced with Harmony, and always eager to learn new tools and technologies. From my early projects to my latest work, I thrive on solving hard problems and delivering solutions that matter.</p>
            </div>
        </div>
    </section>
  )
}
